export class LoggingModuleOptions {
  logLevel: LogLevel;
}

export enum LogLevel {
  TRACE = 0,
  DEBUG = 1,
  INFO = 2,
  WARN = 3,
  ERROR = 4,
}

export abstract class SyncLogMessage {
  message: string;
  logLevel: LogLevel;

  constructor(message: string) {
    this.message = message;
  }
}

export class TraceSyncLogMessage extends SyncLogMessage {
  logLevel = LogLevel.TRACE;

  constructor(message: string) {
    super(message);
  }
}

export class DebugSyncLogMessage extends SyncLogMessage {
  logLevel = LogLevel.DEBUG;

  constructor(message: string) {
    super(message);
  }
}

export class InfoSyncLogMessage extends SyncLogMessage {
  logLevel = LogLevel.INFO;

  constructor(message: string) {
    super(message);
  }
}

export class WarnSyncLogMessage extends SyncLogMessage {
  logLevel = LogLevel.WARN;

  constructor(message: string) {
    super(message);
  }
}

export class ErrorSyncLogMessage extends SyncLogMessage {
  logLevel = LogLevel.ERROR;
  error: Error;

  constructor(error: Error, message: string) {
    super(message);
    this.error = error;
  }
}
